import {
    ADD_CHECKBOX_TIRE,
    CLEAR_CHECKBOX_TIRES,
    DECREMENT_SEARCH_QUANTITY,
    INCREMENT_SEARCH_QUANTITY,
    NEW_TIRE,
    REMOVE_CHECKBOX_TIRE,
    RESET_SEARCH_QUANTITIES,
    SET_AXIOS_CANCEL_SOURCE,
    SET_BRANDS_LIST,
    SET_CLASSIFICATION,
    SET_FILTERED_RESULT,
    SET_INDEX,
    SET_LOADS_LIST,
    SET_ORIGINAL_EQUIPMENT,
    SET_SEARCH_QUANTITY,
    SET_SEARCH_RESULT,
    SET_SEARCH_RESULT_BRAND,
    SET_SEARCH_SORT,
    SET_SEARCH_TERM,
    SET_SPEED_RATING_LIST,
    SET_SPINNER,
    SET_TIRE_TYPES_LIST,
    UPDATE_FILTERS,
    SET_FILTER_DIALOG_FLAG,
    SET_TIRE_SIZE_DIALOG_FLAG,
    UPDATE_RESULTS,
    SET_CLEAR_CHECKBOX_SNACKBAR
} from "./ActionTypes";
import {DEFAULT_QUANTITY} from "../../shared/constants";

const initialState = {
    brandsList: [],
    brandResults: [],
    checkboxes: [],
    classificationList: [],
    detailIndex: 0,
    filteredResults: [],
    loadsList: [],
    newTire: false,
    originalEquipment: [],
    results: [],
    speedRatingList: [],
    spinner: true,
    sortValue: 'Sort By',
    tireTypesList: [],
    updateFilter: false,
    filterDialogFlag: false,
    tireSizeDialogFlag: false,
    updateResult: false,
    snackbar:false,
    searchTerm: '',
    axiosCancelSource: null,
};

const searchResultReducer = (state = initialState, action) => {
    if (action.payload) {
        switch (action.type) {
            case ADD_CHECKBOX_TIRE: {
                return {
                    ...state,
                    checkboxes: [...state.checkboxes, action.payload.gmPartNum]
                }
            }
            case CLEAR_CHECKBOX_TIRES: {
                state.filteredResults.forEach((tire) =>{ if(tire.selected){tire.selected = false} })
                return Object.assign({
                    ...state,
                    checkboxes: [],
                });
            }
            case INCREMENT_SEARCH_QUANTITY: {
                const index = state.results.findIndex(tire => tire.gmPartNum === action.payload.gmPartNum);
                const newResults = [...state.results];
                newResults[index].quantity = newResults[index].quantity + 1;
                return {
                    ...state,
                    results: newResults
                }
            }
            case DECREMENT_SEARCH_QUANTITY: {
                const index = state.results.findIndex(tire => tire.gmPartNum === action.payload.gmPartNum);
                const newResults = [...state.results];
                newResults[index].quantity = newResults[index].quantity - 1;
                return {
                    ...state,
                    results: newResults
                }
            }
            case NEW_TIRE: {
                return Object.assign({}, state, {
                    newTire: (state.newTire = action.payload.newTire),
                });
            }
            case REMOVE_CHECKBOX_TIRE: {
                return {
                    ...state,
                    checkboxes: state.checkboxes.filter(i => i !== action.payload.gmPartNum)
                }
            }
            case RESET_SEARCH_QUANTITIES: {
                const newResults = [...state.results];
                newResults.forEach(t => {
                    t.quantity = DEFAULT_QUANTITY;
                });
                return {
                    ...state,
                    results: newResults
                }
            }
            case SET_SPINNER: {
                return Object.assign({}, state, {
                    spinner: (state.spinner = action.payload.spinner),
                });
            }
            case SET_SEARCH_QUANTITY: {
                const index = state.results.findIndex(tire => tire.gmPartNum === action.payload.gmPartNum);
                const newResults = [...state.results];
                newResults[index].quantity = action.payload.quantity;
                return {
                    ...state,
                    results: newResults
                }
            }
            case SET_SEARCH_RESULT: {
                return Object.assign({
                    ...state,
                    results: action.payload
                });
            }
            case SET_FILTERED_RESULT: {
                return Object.assign({
                    ...state,
                    filteredResults: action.payload
                });
            }
            case SET_ORIGINAL_EQUIPMENT: {
                return Object.assign({
                    ...state,
                    originalEquipment: action.payload
                });
            }
            case SET_SEARCH_RESULT_BRAND: {
                return Object.assign({}, state, {
                    newState: (state.brandResults = action.payload),
                });
            }
            case SET_BRANDS_LIST: {
                return Object.assign({
                    ...state,
                    brandsList: action.payload
                });
            }
            case SET_SPEED_RATING_LIST: {
                return Object.assign({
                    ...state,
                    speedRatingList: action.payload
                });
            }
            case SET_LOADS_LIST: {
                return Object.assign({
                    ...state,
                    loadsList: action.payload
                });
            }
            case SET_TIRE_TYPES_LIST: {
                return Object.assign({
                    ...state,
                    tireTypesList: action.payload
                });
            }
            case SET_CLASSIFICATION: {
                return Object.assign({
                    ...state,
                    classificationList: action.payload
                });
            }
            case SET_INDEX: {
                const index = state.filteredResults.findIndex(tire => tire.gmPartNum === action.payload.gmPartNum);
                return Object.assign({}, state, {
                    newState: (state.detailIndex = index),
                });
            }
            case SET_SEARCH_SORT: {
                return Object.assign({}, state, {
                    newState: (state.sortValue = action.payload),
                });
            }
            case UPDATE_RESULTS: {
                return Object.assign({}, state, {
                    updateResult: (state.updateResult = action.payload.updateResult),
                });
            }
            case SET_CLEAR_CHECKBOX_SNACKBAR: {
                return Object.assign({}, state, {
                    snackbar: (state.snackbar = action.payload.snackbar),
                });
            }
            case UPDATE_FILTERS: {
                return Object.assign({}, state, {
                    updateFilter: (state.updateFilter = action.payload.updateFilter),
                });
            }
            case SET_FILTER_DIALOG_FLAG: {
                return Object.assign({}, state, {
                    filterDialogFlag: (state.filterDialogFlag = action.payload.filterDialogFlag),
                });
            }
            case SET_TIRE_SIZE_DIALOG_FLAG: {
                return Object.assign({}, state, {
                    tireSizeDialogFlag: (state.tireSizeDialogFlag = action.payload.tireSizeDialogFlag),
                });
            }
            case SET_SEARCH_TERM: {
                return Object.assign({}, state, {
                    newState: (state.searchTerm = action.payload.searchTerm),
                });
            }
            case SET_AXIOS_CANCEL_SOURCE: {
                return {
                    ...state,
                    axiosCancelSource: action.payload.axiosCancelSource
                }
            }
            default:
                return state;
        }
    }
    else {
        return state;
    }

};

export default searchResultReducer;
